// extracted by mini-css-extract-plugin
export var modal = "_u0-0";
export var table = "_u0-1";